export class DiscordAnnualMembershipPrices {
    static readonly PLUS = 7499
    static readonly PREMIUM = 14999
    static readonly ELITE = 19999
}
